module.exports = __webpack_public_path__ + "media/src/images/jsda_banner-6a83b722a53a9fba35b72e2c1b65cec5.png";